/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ResourceHelper} from '../../../util/resource-helper';
import {AdnHttpService} from '../../../util/adn-http.service';
import {transformJsonObjectProperty} from '../../../util/adn-http-resource-transforms';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the MarketplaceProductOptions HTTP resource (factory product). */
export class MarketplaceProductOptionsResource {
}

/** Angular DI token for the MarketplaceProduct HTTP resource (factory product). */
export class MarketplaceProductResource {
}

export function createMarketplaceProductOptionsResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  return createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'axproduct/options',
    () => localUserProfile,
    'axProductOptions'
  );
}

export function createMarketplaceProductResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const jsonTransforms = transformJsonObjectProperty('data');
  return createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'axproduct',
    () => localUserProfile,
    'axProduct',
    undefined,
    {
      transformRequest(product: any): any {
        const transformed = _.cloneDeep(product);
        ['minimumCpm', 'minimumCpc', 'minimumBudget', 'maximumBudget'].forEach((fieldName: string) => {
          ResourceHelper.checkMoney(transformed, [fieldName]);
        });
        return jsonTransforms.transformRequest(transformed);
      },
      transformResponse: jsonTransforms.transformResponse
    }
  );
}

export const marketplaceProductOptionsResourceProvider = {
  provide: MarketplaceProductOptionsResource,
  useFactory: createMarketplaceProductOptionsResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

export const marketplaceProductResourceProvider = {
  provide: MarketplaceProductResource,
  useFactory: createMarketplaceProductResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

